// GENERATED FILE - DO NOT MODIFY

export enum Features {
    AddressArea = 'addressArea',
    AddressAreaAddressesSave = 'addressAreaAddressesSave',
    AddressAreaBuildingsSave = 'addressAreaBuildingsSave',
    AddressAreaDetail = 'addressAreaDetail',
    AddressAreaDetailDelete = 'addressAreaDetailDelete',
    AddressAreaSave = 'addressAreaSave',
    AfasAanafwezigheid = 'afasAanafwezigheid',
    AfasAuthDeleteexistingSave = 'afasAuthDeleteexistingSave',
    AfasAuthRequestotpSave = 'afasAuthRequestotpSave',
    AfasAuthValidateotpSave = 'afasAuthValidateotpSave',
    AfasDownloadInvoicesSave = 'afasDownloadInvoicesSave',
    AfasEmployees = 'afasEmployees',
    AfasFunctions = 'afasFunctions',
    AfasFunctions_key_Save = 'afasFunctions_key_Save',
    AfasHourtypes = 'afasHourtypes',
    AfasIllness = 'afasIllness',
    AfasInvoices = 'afasInvoices',
    AfasLeaves = 'afasLeaves',
    AfasMaterieel = 'afasMaterieel',
    AfasOwnAanafwezigheid = 'afasOwnAanafwezigheid',
    AfasProfile = 'afasProfile',
    AfasProjects = 'afasProjects',
    AfasRealization = 'afasRealization',
    AfasRooster = 'afasRooster',
    AfasSync = 'afasSync',
    AiMessagesResults_messageId_ = 'aiMessagesResults_messageId_',
    AiReports = 'aiReports',
    AiReports_reportId_Delete = 'aiReports_reportId_Delete',
    AiReportsClearSave = 'aiReportsClearSave',
    AiReportsMessages = 'aiReportsMessages',
    AiReportsMessages_reportId_ = 'aiReportsMessages_reportId_',
    Airtable = 'airtable',
    AirtableGemeenten = 'airtableGemeenten',
    AirtableProvincies = 'airtableProvincies',
    AirtableWaterschappen = 'airtableWaterschappen',
    AiSearchSave = 'aiSearchSave',
    AiSendMessageSave = 'aiSendMessageSave',
    AllCustomers = 'allCustomers',
    Articles = 'articles',
    ArticlesCrmAiSuggestionDetailSave = 'articlesCrmAiSuggestionDetailSave',
    ArticlesCrmDetailArticleModify = 'articlesCrmDetailArticleModify',
    ArticlesCrmDetailAutomationsModify = 'articlesCrmDetailAutomationsModify',
    ArticlesCrmDetailDelete = 'articlesCrmDetailDelete',
    ArticlesCrmDetailLinkSave = 'articlesCrmDetailLinkSave',
    ArticlesCrmDetailModify = 'articlesCrmDetailModify',
    ArticlesCrmDetailSyncAfasSave = 'articlesCrmDetailSyncAfasSave',
    ArticlesCrmOverrideDetailSave = 'articlesCrmOverrideDetailSave',
    ArticlesCustomer_customerId_ = 'articlesCustomer_customerId_',
    ArticlesCustomer_customerId_AiSuggestionsSave = 'articlesCustomer_customerId_AiSuggestionsSave',
    ArticlesCustomer_customerId_Delete = 'articlesCustomer_customerId_Delete',
    ArticlesCustomer_customerId_ImportSave = 'articlesCustomer_customerId_ImportSave',
    ArticlesCustomer_customerId_Projects = 'articlesCustomer_customerId_Projects',
    ArticlesCustomer_customerId_SyncAfasSave = 'articlesCustomer_customerId_SyncAfasSave',
    ArticlesCustomer_customerId_UnlinkedDelete = 'articlesCustomer_customerId_UnlinkedDelete',
    ArticlesDayreportsCustomer_customerId_ = 'articlesDayreportsCustomer_customerId_',
    ArticlesDayreportsUnprocessedOverview = 'articlesDayreportsUnprocessedOverview',
    ArticlesDetailUpdate = 'articlesDetailUpdate',
    ArticlesGeneric = 'articlesGeneric',
    ArticlesGenericAiSuggestionsSave = 'articlesGenericAiSuggestionsSave',
    ArticlesGenericDelete = 'articlesGenericDelete',
    ArticlesGenericImportSave = 'articlesGenericImportSave',
    ArticlesGenericUnlinkedDelete = 'articlesGenericUnlinkedDelete',
    Asphalt = 'asphalt',
    AsphaltAsphaltlist_millid__date_ = 'asphaltAsphaltlist_millid__date_',
    AsphaltExport = 'asphaltExport',
    AsphaltImportCorrectionSave = 'asphaltImportCorrectionSave',
    AsphaltImportSave = 'asphaltImportSave',
    AsphaltMillAsphaltDetailDelete = 'asphaltMillAsphaltDetailDelete',
    AsphaltMills = 'asphaltMills',
    AuthAddFeatureToFunctionalitySave = 'authAddFeatureToFunctionalitySave',
    AuthAddFunctionalityToRoleSave = 'authAddFunctionalityToRoleSave',
    AuthFeatures = 'authFeatures',
    AuthFirebaseSave = 'authFirebaseSave',
    AuthFunctionalities = 'authFunctionalities',
    AuthLoginAsDirkUserSave = 'authLoginAsDirkUserSave',
    AuthLoginAsUserSave = 'authLoginAsUserSave',
    AuthMeProfilePictureSave = 'authMeProfilePictureSave',
    AuthMeSessions = 'authMeSessions',
    AuthMeSettings_moduleKey_Modify = 'authMeSettings_moduleKey_Modify',
    AuthRemoveFeatureFromFunctionalitySave = 'authRemoveFeatureFromFunctionalitySave',
    AuthRemoveFunctionalityFromRoleSave = 'authRemoveFunctionalityFromRoleSave',
    AuthRightsMap = 'authRightsMap',
    AuthRoles = 'authRoles',
    Chats = 'chats',
    ChatsAdminSave = 'chatsAdminSave',
    ChatsDelete = 'chatsDelete',
    ChatsMessage = 'chatsMessage',
    ChatsMessageDelete = 'chatsMessageDelete',
    ChatsMessageReadSave = 'chatsMessageReadSave',
    ChatsMessageSave = 'chatsMessageSave',
    ChatsMute = 'chatsMute',
    ChatsSave = 'chatsSave',
    ChatsUsers = 'chatsUsers',
    Checklist = 'checklist',
    ChecklistAnswers = 'checklistAnswers',
    ChecklistAnswers_all_ = 'checklistAnswers_all_',
    ChecklistAnswersAll = 'checklistAnswersAll',
    ChecklistAnswersDetail = 'checklistAnswersDetail',
    ChecklistAnswersDetailDelete = 'checklistAnswersDetailDelete',
    ChecklistAnswersForemans = 'checklistAnswersForemans',
    ChecklistAnswersInspectors = 'checklistAnswersInspectors',
    ChecklistAnswersPdfDetail = 'checklistAnswersPdfDetail',
    ChecklistAnswersPendingSignOff = 'checklistAnswersPendingSignOff',
    ChecklistAnswersSave = 'checklistAnswersSave',
    ChecklistAnswersSignOff = 'checklistAnswersSignOff',
    ChecklistType = 'checklistType',
    ChecklistTypeAvailable = 'checklistTypeAvailable',
    ChecklistTypeComplianceReport = 'checklistTypeComplianceReport',
    ChecklistTypeComplianceReportPdf = 'checklistTypeComplianceReportPdf',
    ChecklistTypeDetail = 'checklistTypeDetail',
    ChecklistTypeDetailDelete = 'checklistTypeDetailDelete',
    ChecklistTypeSave = 'checklistTypeSave',
    CodaltAppLogs = 'codaltAppLogs',
    CodaltAppLogsDetail = 'codaltAppLogsDetail',
    CodaltClientDevices = 'codaltClientDevices',
    CodaltDownloadDatabase = 'codaltDownloadDatabase',
    CodaltDump = 'codaltDump',
    CodaltFailedJobs = 'codaltFailedJobs',
    CodaltFailedJobsDetail = 'codaltFailedJobsDetail',
    CodaltFailedJobsFilters = 'codaltFailedJobsFilters',
    CodaltLogsFiles = 'codaltLogsFiles',
    CodaltLogsFiles_fileId_ = 'codaltLogsFiles_fileId_',
    CodaltLogsFilters = 'codaltLogsFilters',
    CodaltPlanningDetails = 'codaltPlanningDetails',
    CodaltTodaySeverity = 'codaltTodaySeverity',
    ConsumptionTypes = 'consumptionTypes',
    Contacts = 'contacts',
    CustomerProjects = 'customerProjects',
    CustomerProjectsConsumers_projectId_ = 'customerProjectsConsumers_projectId_',
    CustomerProjectsCountDetail = 'customerProjectsCountDetail',
    CustomerProjectsCounts = 'customerProjectsCounts',
    CustomerProjectsDetail = 'customerProjectsDetail',
    CustomerProjectsDetailAccess = 'customerProjectsDetailAccess',
    CustomerProjectsDetailAccess_userId_Delete = 'customerProjectsDetailAccess_userId_Delete',
    CustomerProjectsDetailAccess_userId_NotificationsSave = 'customerProjectsDetailAccess_userId_NotificationsSave',
    CustomerProjectsDetailAccessGrantSave = 'customerProjectsDetailAccessGrantSave',
    CustomerProjectsDetailAccessRequestSave = 'customerProjectsDetailAccessRequestSave',
    CustomerProjectsDetailDelete = 'customerProjectsDetailDelete',
    CustomerProjectsDetailDetail = 'customerProjectsDetailDetail',
    CustomerProjectsDetailMailOverview = 'customerProjectsDetailMailOverview',
    CustomerProjectsDownloadDetail = 'customerProjectsDownloadDetail',
    CustomerProjectsEditUsers_customerId_ = 'customerProjectsEditUsers_customerId_',
    CustomerProjectsFollowSave = 'customerProjectsFollowSave',
    CustomerProjectsNames = 'customerProjectsNames',
    CustomerProjectsPendingAccessCounts = 'customerProjectsPendingAccessCounts',
    CustomerProjectsPhasesActiveSave = 'customerProjectsPhasesActiveSave',
    CustomerProjectsPhasesActivityAssignees_customerId_ = 'customerProjectsPhasesActivityAssignees_customerId_',
    CustomerProjectsPhasesActivityDetailDelete = 'customerProjectsPhasesActivityDetailDelete',
    CustomerProjectsPhasesActivityOrderSave = 'customerProjectsPhasesActivityOrderSave',
    CustomerProjectsPhasesActivitySave = 'customerProjectsPhasesActivitySave',
    CustomerProjectsPhasesDetailDelete = 'customerProjectsPhasesDetailDelete',
    CustomerProjectsPhasesDoneSave = 'customerProjectsPhasesDoneSave',
    CustomerProjectsPhasesOrderSave = 'customerProjectsPhasesOrderSave',
    CustomerProjectsPhasesReplyDetailDelete = 'customerProjectsPhasesReplyDetailDelete',
    CustomerProjectsPhasesReplySave = 'customerProjectsPhasesReplySave',
    CustomerProjectsPhasesSave = 'customerProjectsPhasesSave',
    CustomerProjectsSave = 'customerProjectsSave',
    CustomerProjectsTemplates = 'customerProjectsTemplates',
    CustomerProjectsUnfollowSave = 'customerProjectsUnfollowSave',
    Customers = 'customers',
    Customers_customerId_Contacts_contactId_ = 'customers_customerId_Contacts_contactId_',
    Customers_custsomerId_Contacts_contactId_Delete = 'customers_custsomerId_Contacts_contactId_Delete',
    CustomersDefaultPdfStyleDetailSave = 'customersDefaultPdfStyleDetailSave',
    CustomersDetail = 'customersDetail',
    CustomersDetailContactsSave = 'customersDetailContactsSave',
    CustomersDetailDelete = 'customersDetailDelete',
    CustomersDetailManagement = 'customersDetailManagement',
    CustomersDetailUpdate = 'customersDetailUpdate',
    CustomersIconSave = 'customersIconSave',
    CustomersPaginated = 'customersPaginated',
    CustomersProjectsNames = 'customersProjectsNames',
    CustomersRecentSorted = 'customersRecentSorted',
    CustomersSave = 'customersSave',
    DayreportsArticlesDetailDelete = 'dayreportsArticlesDetailDelete',
    DayreportsPdf_planningId_ = 'dayreportsPdf_planningId_',
    DayreportsPlanning_planningId_ = 'dayreportsPlanning_planningId_',
    DayreportsSave = 'dayreportsSave',
    Declarations = 'declarations',
    DeclarationsCustomer_customerId_ = 'declarationsCustomer_customerId_',
    DeclarationsDetail = 'declarationsDetail',
    DeclarationsDetailDayreports = 'declarationsDetailDayreports',
    DeclarationsDetailDayreports_dayreportId_Delete = 'declarationsDetailDayreports_dayreportId_Delete',
    DeclarationsDetailDayreportsSave = 'declarationsDetailDayreportsSave',
    DeclarationsDetailDelete = 'declarationsDetailDelete',
    DeclarationsDetailPdf = 'declarationsDetailPdf',
    DeclarationsDetailSave = 'declarationsDetailSave',
    DeclarationsProcessSave = 'declarationsProcessSave',
    Documents_chapterId_Delete = 'documents_chapterId_Delete',
    DocumentsAddCameraImageSave = 'documentsAddCameraImageSave',
    DocumentsAddChapterSave = 'documentsAddChapterSave',
    DocumentsChangeOrderSave = 'documentsChangeOrderSave',
    DocumentsDetail = 'documentsDetail',
    DocumentsDownload_chapterId_ = 'documentsDownload_chapterId_',
    DocumentsDownload_chapterId__download_ = 'documentsDownload_chapterId__download_',
    DocumentsRenameChapterSave = 'documentsRenameChapterSave',
    DocumentsThumb_chapterId_ = 'documentsThumb_chapterId_',
    DocumentsUpload_parentChapterId_Save = 'documentsUpload_parentChapterId_Save',
    DocumentsUploadSave = 'documentsUploadSave',
    DynamicPerformer = 'dynamicPerformer',
    Entities = 'entities',
    EntitiesChangeOrderSave = 'entitiesChangeOrderSave',
    EntitiesDetail = 'entitiesDetail',
    EntitiesEntityUnavailable = 'entitiesEntityUnavailable',
    EntitiesNotAvailableSave = 'entitiesNotAvailableSave',
    EntitiesSave = 'entitiesSave',
    EntitiesSaveAll = 'entitiesSaveAll',
    EntitiesSaveVkm = 'entitiesSaveVkm',
    EntitiesTypes = 'entitiesTypes',
    ExecutorSchedule = 'executorSchedule',
    ExecutorScheduleBulkSave = 'executorScheduleBulkSave',
    ExecutorScheduleBulkUpdate = 'executorScheduleBulkUpdate',
    ExecutorScheduleDeleteBulkSave = 'executorScheduleDeleteBulkSave',
    ExecutorScheduleDetailDelete = 'executorScheduleDetailDelete',
    ExecutorScheduleDetailUpdate = 'executorScheduleDetailUpdate',
    ExecutorScheduleSave = 'executorScheduleSave',
    File_storage__filepath_ = 'file_storage__filepath_',
    FileManagerDelete = 'fileManagerDelete',
    FileManagerDownload_download_ = 'fileManagerDownload_download_',
    FileManagerRead = 'fileManagerRead',
    FileManagerRead_dir_ = 'fileManagerRead_dir_',
    FileManagerRotateImage = 'fileManagerRotateImage',
    FileManagerUploadSave = 'fileManagerUploadSave',
    FileUploadSave = 'fileUploadSave',
    GeocodeGeocode = 'geocodeGeocode',
    GeocodeReverseGeocode = 'geocodeReverseGeocode',
    Hectopins = 'hectopins',
    HectopinsNearby = 'hectopinsNearby',
    HectopinsSearchSave = 'hectopinsSearchSave',
    Hiring = 'hiring',
    HiringAll = 'hiringAll',
    HiringSave = 'hiringSave',
    Leave = 'leave',
    LeaveDetail = 'leaveDetail',
    LeaveDetailDelete = 'leaveDetailDelete',
    LeaveExecutor = 'leaveExecutor',
    LeaveRealisationsDetail = 'leaveRealisationsDetail',
    LeaveSave = 'leaveSave',
    LocationAuto = 'locationAuto',
    MaterialColors = 'materialColors',
    MaterialRawMaterialsToggleOptionalSave = 'materialRawMaterialsToggleOptionalSave',
    MaterialRawMaterialsUpdateSave = 'materialRawMaterialsUpdateSave',
    Materials = 'materials',
    MaterialsOptionals_materialId_ = 'materialsOptionals_materialId_',
    MaterialsOptionalsPlanning_planningMaterialId_ = 'materialsOptionalsPlanning_planningMaterialId_',
    MaterialsPlanning_planningId_ = 'materialsPlanning_planningId_',
    MaterialsRawMaterialsDelete = 'materialsRawMaterialsDelete',
    MaterialsRawMaterialsSave = 'materialsRawMaterialsSave',
    MaterialTypes = 'materialTypes',
    News = 'news',
    News_limit__skip_ = 'news_limit__skip_',
    NewsAddDocumentSave = 'newsAddDocumentSave',
    NewsAddImageSave = 'newsAddImageSave',
    NewsDetail = 'newsDetail',
    NewsDetailDelete = 'newsDetailDelete',
    NewsLikeSave = 'newsLikeSave',
    NewsReserveSave = 'newsReserveSave',
    NewsRmDocumentDetailDelete = 'newsRmDocumentDetailDelete',
    NewsRmImageDetailDelete = 'newsRmImageDetailDelete',
    NewsSave = 'newsSave',
    NewsSortDocumentsSave = 'newsSortDocumentsSave',
    NewsSortImagesSave = 'newsSortImagesSave',
    Notifications = 'notifications',
    NotificationsDeleteSave = 'notificationsDeleteSave',
    NotificationsFailed = 'notificationsFailed',
    NotificationsMarkReadSave = 'notificationsMarkReadSave',
    NotificationsMarkUnreadSave = 'notificationsMarkUnreadSave',
    NotificationsRead = 'notificationsRead',
    NotificationsRunning = 'notificationsRunning',
    NotificationsUnread = 'notificationsUnread',
    OrderdirectInvoices = 'orderdirectInvoices',
    OrderdirectInvoicesDetail = 'orderdirectInvoicesDetail',
    OrderdirectInvoicesResetStatusDetailSave = 'orderdirectInvoicesResetStatusDetailSave',
    OrderdirectInvoicesSendAllToAfasSave = 'orderdirectInvoicesSendAllToAfasSave',
    OrderdirectInvoicesSendToAfasDetailSave = 'orderdirectInvoicesSendToAfasDetailSave',
    OrderdirectInvoicesSyncSave = 'orderdirectInvoicesSyncSave',
    OrderdirectPurchaseInvoices = 'orderdirectPurchaseInvoices',
    OrderdirectPurchaseInvoicesDetail = 'orderdirectPurchaseInvoicesDetail',
    OrderdirectPurchaseInvoicesResetStatusDetailSave = 'orderdirectPurchaseInvoicesResetStatusDetailSave',
    OrderdirectPurchaseInvoicesSendAllToAfasSave = 'orderdirectPurchaseInvoicesSendAllToAfasSave',
    OrderdirectPurchaseInvoicesSendToAfasDetailSave = 'orderdirectPurchaseInvoicesSendToAfasDetailSave',
    OrderdirectPurchaseInvoicesSyncSave = 'orderdirectPurchaseInvoicesSyncSave',
    PasswordLoginRequired = 'passwordLoginRequired',
    PdfAddressareaDetail = 'pdfAddressareaDetail',
    PdfApplyBackgroundSave = 'pdfApplyBackgroundSave',
    PdfReportpdfSave = 'pdfReportpdfSave',
    PdfStyles = 'pdfStyles',
    PdfWorkareapdf = 'pdfWorkareapdf',
    Persons = 'persons',
    PersonsDetail = 'personsDetail',
    PersonsDetailUpdate = 'personsDetailUpdate',
    PersonsSave = 'personsSave',
    Planning = 'planning',
    Planning_planningId_ = 'planning_planningId_',
    PlanningAsphaltPerformer = 'planningAsphaltPerformer',
    PlanningAutocomplete = 'planningAutocomplete',
    PlanningCheckSave = 'planningCheckSave',
    PlanningDetailDelete = 'planningDetailDelete',
    PlanningDetailHistory = 'planningDetailHistory',
    PlanningEmployeePdf_week__year_ = 'planningEmployeePdf_week__year_',
    PlanningFile_planningFileId_ = 'planningFile_planningFileId_',
    PlanningFixed = 'planningFixed',
    PlanningFixedDaysSave = 'planningFixedDaysSave',
    PlanningFixedSave = 'planningFixedSave',
    PlanningHiringNames = 'planningHiringNames',
    PlanningHiringNames_entityId_ = 'planningHiringNames_entityId_',
    PlanningMultiSave = 'planningMultiSave',
    PlanningPdf_date_ = 'planningPdf_date_',
    PlanningPlanningHas = 'planningPlanningHas',
    PlanningPlanningText = 'planningPlanningText',
    PlanningPlanningTextSave = 'planningPlanningTextSave',
    PlanningProjectManager = 'planningProjectManager',
    PlanningProjectsForDate = 'planningProjectsForDate',
    PlanningRelatedPlannings_afasProjectId_ = 'planningRelatedPlannings_afasProjectId_',
    PlanningRepetition = 'planningRepetition',
    PlanningRepetition_fromPlanningId_Delete = 'planningRepetition_fromPlanningId_Delete',
    PlanningRepetition_repetitionId_Save = 'planningRepetition_repetitionId_Save',
    PlanningRepetitionSave = 'planningRepetitionSave',
    PlanningSave = 'planningSave',
    PlanningSaveSave = 'planningSaveSave',
    PlanningSaveSortSave = 'planningSaveSortSave',
    PlanningSearch = 'planningSearch',
    PlanningSingleDelete = 'planningSingleDelete',
    PlanningSingleSave = 'planningSingleSave',
    PlanningStatus = 'planningStatus',
    PlanningStatusSave = 'planningStatusSave',
    PlanningTransportPdf_date_ = 'planningTransportPdf_date_',
    PlanningUserPlanning = 'planningUserPlanning',
    Project = 'project',
    Project_projectid_ = 'project_projectid_',
    ProjectAsphalt = 'projectAsphalt',
    ProjectAsphaltSave = 'projectAsphaltSave',
    ProjectComment = 'projectComment',
    ProjectCommentHistory = 'projectCommentHistory',
    ProjectCommentSave = 'projectCommentSave',
    ProjectRecent = 'projectRecent',
    ProjectReports_projectid_ = 'projectReports_projectid_',
    ProjectReportsPdf_projectid_ = 'projectReportsPdf_projectid_',
    ProjectSave = 'projectSave',
    ProjectSearch = 'projectSearch',
    PullrequestLastUpdate = 'pullrequestLastUpdate',
    RawMaterials = 'rawMaterials',
    RawMaterialsDetailUpdate = 'rawMaterialsDetailUpdate',
    RealisationDayEntities = 'realisationDayEntities',
    RealisationDayExecutors = 'realisationDayExecutors',
    RealisationHiringNames = 'realisationHiringNames',
    RealisationHistory = 'realisationHistory',
    RealisationPeriodProjects = 'realisationPeriodProjects',
    RealisationScheduleApproveSave = 'realisationScheduleApproveSave',
    RealisationScheduleDay = 'realisationScheduleDay',
    RealisationScheduleFirstUnsubmitted = 'realisationScheduleFirstUnsubmitted',
    RealisationScheduleMovePerformerSave = 'realisationScheduleMovePerformerSave',
    RealisationSchedulePauseSave = 'realisationSchedulePauseSave',
    RealisationSchedulePlanning_planningId_ = 'realisationSchedulePlanning_planningId_',
    RealisationSchedulePreviousOpen = 'realisationSchedulePreviousOpen',
    RealisationScheduleProject = 'realisationScheduleProject',
    RealisationScheduleSaveSave = 'realisationScheduleSaveSave',
    RealisationScheduleSubmitSave = 'realisationScheduleSubmitSave',
    RealisationScheduleUser = 'realisationScheduleUser',
    RealisationScheduleUserDay = 'realisationScheduleUserDay',
    RealisationScheduleUserDayTotals = 'realisationScheduleUserDayTotals',
    RealisationUser_userid__bookdate_ = 'realisationUser_userid__bookdate_',
    RealisationWeekReportPdf_project__week__year__onlyTotals__noHours__noComments__noAsphalt__noCars_ = 'realisationWeekReportPdf_project__week__year__onlyTotals__noHours__noComments__noAsphalt__noCars_',
    SettlementChangeProjectSave = 'settlementChangeProjectSave',
    SettlementCounts = 'settlementCounts',
    SettlementDelete = 'settlementDelete',
    SettlementDetailDelete = 'settlementDetailDelete',
    SettlementHourtypes = 'settlementHourtypes',
    SettlementList = 'settlementList',
    SettlementMultiSave = 'settlementMultiSave',
    SettlementPeriod_userid_ = 'settlementPeriod_userid_',
    SettlementPeriodSettlementAllPdf_year__month_ = 'settlementPeriodSettlementAllPdf_year__month_',
    SettlementPeriodSettlementSinglePdf_year__month__userid_ = 'settlementPeriodSettlementSinglePdf_year__month__userid_',
    SettlementSave = 'settlementSave',
    SettlementSendSave = 'settlementSendSave',
    SettlementTill = 'settlementTill',
    Status = 'status',
    Suppliers = 'suppliers',
    Surveys_surveyId_Save = 'surveys_surveyId_Save',
    SurveysAnswers_surveyId_ = 'surveysAnswers_surveyId_',
    SurveysAnswers_surveyId_Delete = 'surveysAnswers_surveyId_Delete',
    SurveysDetailDelete = 'surveysDetailDelete',
    SurveysSave = 'surveysSave',
    Tickets = 'tickets',
    TicketsComments_ticketid_ = 'ticketsComments_ticketid_',
    TicketsComments_ticketid_Save = 'ticketsComments_ticketid_Save',
    TicketsDetail = 'ticketsDetail',
    TicketsDetailUpdate = 'ticketsDetailUpdate',
    TicketsSave = 'ticketsSave',
    TicketTypes = 'ticketTypes',
    Timeline = 'timeline',
    Timeline_limit__skip_ = 'timeline_limit__skip_',
    TimelineAddDocumentSave = 'timelineAddDocumentSave',
    TimelineAddImageSave = 'timelineAddImageSave',
    TimelineDetail = 'timelineDetail',
    TimelineDetailDelete = 'timelineDetailDelete',
    TimelineReserveSave = 'timelineReserveSave',
    TimelineRmDocumentDetailDelete = 'timelineRmDocumentDetailDelete',
    TimelineRmImageDetailDelete = 'timelineRmImageDetailDelete',
    TimelineSave = 'timelineSave',
    TimelineSortDocumentsSave = 'timelineSortDocumentsSave',
    TimelineSortImagesSave = 'timelineSortImagesSave',
    Toolbox = 'toolbox',
    Toolbox_toolboxid_Delete = 'toolbox_toolboxid_Delete',
    Toolbox_toolboxid_ = 'toolbox6_toolboxid_',
    ToolboxQuestions_toolboxid_Save = 'toolbox6Questions_toolboxid_Save',
    ToolboxCurrent = 'toolboxCurrent',
    ToolboxPdf_toolboxid_ = 'toolboxPdf_toolboxid_',
    ToolboxQuestionAnswer_toolboxid_ = 'toolboxQuestionAnswer_toolboxid_',
    ToolboxQuestionAnswerSave = 'toolboxQuestionAnswerSave',
    ToolboxQuestions_questionId_Delete = 'toolboxQuestions_questionId_Delete',
    ToolboxQuestions_toolboxid_ = 'toolboxQuestions_toolboxid_',
    ToolboxQuestionsAnswers_toolboxid_ = 'toolboxQuestionsAnswers_toolboxid_',
    ToolboxQuestionsChoice_choiceid_Delete = 'toolboxQuestionsChoice_choiceid_Delete',
    ToolboxQuestionsSave_toolboxid_Save = 'toolboxQuestionsSave_toolboxid_Save',
    ToolboxRead_toolboxid_ = 'toolboxRead_toolboxid_',
    ToolboxReadBy_toolboxid_ = 'toolboxReadBy_toolboxid_',
    ToolboxSave = 'toolboxSave',
    UserPlanningDetailDelete = 'userPlanningDetailDelete',
    UserPlanningProjectSave = 'userPlanningProjectSave',
    UserPlanningSave = 'userPlanningSave',
    Users = 'users',
    Users_userId_ = 'users_userId_',
    Users_userId_AuthSessions = 'users_userId_AuthSessions',
    Users_userId_Delete = 'users_userId_Delete',
    Users_userId_ResetLoginAttemptsSave = 'users_userId_ResetLoginAttemptsSave',
    Users_userId_Settings_moduleKey_Modify = 'users_userId_Settings_moduleKey_Modify',
    UsersCustomerHistory_userId_ = 'usersCustomerHistory_userId_',
    UsersFunctions = 'usersFunctions',
    UsersNewPassword_userId_ = 'usersNewPassword_userId_',
    UsersNewPin_userId_ = 'usersNewPin_userId_',
    UsersPaginated = 'usersPaginated',
    UsersRoleHistory_userId_ = 'usersRoleHistory_userId_',
    UsersSave = 'usersSave',
    VkmChecklistAnswers = 'vkmChecklistAnswers',
    VkmChecklistAnswersAll = 'vkmChecklistAnswersAll',
    VkmChecklistAnswersSave = 'vkmChecklistAnswersSave',
    VkmChecklistQuestions = 'vkmChecklistQuestions',
    VkmCountsAndPrices_planningid_ = 'vkmCountsAndPrices_planningid_',
    VkmEntityUpdateSave = 'vkmEntityUpdateSave',
    VkmExcelExport = 'vkmExcelExport',
    VkmIdByProject_project_ = 'vkmIdByProject_project_',
    VkmPdf_planningid__planninghasid_ = 'vkmPdf_planningid__planninghasid_',
    VkmSave = 'vkmSave',
    VkmSaveVehicleSave = 'vkmSaveVehicleSave',
    VkmVehicle = 'vkmVehicle',
    VkmWorkorders = 'vkmWorkorders',
    WeatherCurrent = 'weatherCurrent',
    Wfs = 'wfs',
    WfsCapabilities = 'wfsCapabilities',
    WfsOptions = 'wfsOptions',
    WfsTokenSave = 'wfsTokenSave',
    Workareas = 'workareas',
    WorkareasAll = 'workareasAll',
    WorkareasAvailableStatuses = 'workareasAvailableStatuses',
    WorkareasDetail = 'workareasDetail',
    WorkareasHistory_workareaId_ = 'workareasHistory_workareaId_',
    WorkareasOptions = 'workareasOptions',
    WorkareasPicture_workareaImageId_Delete = 'workareasPicture_workareaImageId_Delete',
    WorkareasPictureSave = 'workareasPictureSave',
    WorkareasReserveRemoveSave = 'workareasReserveRemoveSave',
    WorkareasReserveSave = 'workareasReserveSave',
    WorkareasSave = 'workareasSave',
    WorkareasTransferSave = 'workareasTransferSave',
}
